import React from "react";
import { Routes, Route } from "react-router-dom";
import "./Dashboard.css";
import { Header, Footer, Sidebar } from "../components/index.js";
import {
  Home,
  Scheduling,
  Analytics,
  GenerateAi,
  Engagements,
  GenerateCaption,
  GenerateContent,
  Profile,
  Instagram,
  Facebook,
  Snapchat,
  Linkedln,
} from "../pages/index.js";
const DashboardLayout = () => {
  return (
    <div className="dashboard-container">
      <div className="d-flex flex-column flex-md-row sidebar-background">
        <Sidebar />
        <div className="flex-grow-1">
          <Header />
          <div className="m-3">
            <Routes>
              <Route path="dashboard" element={<Home />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="scheduling" element={<Scheduling />} />
              <Route path="engagements" element={<Engagements />} />
              <Route path="ai" element={<GenerateAi />} />
              <Route path="caption" element={<GenerateCaption />} />
              <Route path="content" element={<GenerateContent />} />
              <Route path="profile" element={<Profile />} />
              <Route path="insta" element={<Instagram />} />
              <Route path="facebook" element={<Facebook />} />
              <Route path="snapchat" element={<Snapchat />} />
              <Route path="linkedln" element={<Linkedln />} />
            </Routes>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default DashboardLayout;